import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[elightFixedDimensions]',
})
export class FixedDimensionsDirective implements AfterViewInit {
    constructor(private elRef: ElementRef, private renderer: Renderer2) {}

    ngAfterViewInit() {
        const elementHeight = this.elRef.nativeElement.offsetHeight;
        const elementWidth = this.elRef.nativeElement.offsetWidth;

        this.renderer.setStyle(
            this.elRef.nativeElement,
            'width',
            `${elementWidth}px`
        );
        this.renderer.setStyle(
            this.elRef.nativeElement,
            'height',
            `${elementHeight}px`
        );
    }
}
